import {
    GET_COUNTRY,
    GET_COUNTRY_SUCCESS,
    GET_COUNTRY_FAILED,

    SUBMIT_COUNTRY_FORM,
    SUBMIT_COUNTRY_FORM_SUCCESS,
    SUBMIT_COUNTRY_FORM_FAILED,

    DELETE_COUNTRY,
    DELETE_COUNTRY_SUCCESS,
    DELETE_COUNTRY_FAILED
} from '../../constants/actionTypes';

const INIT_STATE = {
    loading: false,
    countries: [],
    submittingForm: false,
    error: null,
    deleting: false
};

const CountryReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_COUNTRY:
            return { ...state, loading: true };
        case GET_COUNTRY_SUCCESS:
            return { ...state, countries: action.payload.data, total: action.payload.total, loading: false, error: null };
        case GET_COUNTRY_FAILED:
            return { ...state, error: action.payload, loading: false };

        case SUBMIT_COUNTRY_FORM:
            return { ...state, error: null, submittingForm: true };
        case SUBMIT_COUNTRY_FORM_SUCCESS:
            const alreadyExists = state.countries.find((country) => country.id === action.payload.id);
            let udpatedCountries;
            let total = state.total;
            if (!alreadyExists) {
                udpatedCountries = [action.payload, ...state.countries];
                total += 1;
            } else {
                udpatedCountries = state.countries.map((country) => {
                if (country.id === action.payload.id) {
                  return action.payload;
                }
                return country;
              });
            }
            return { ...state, total,  countries: udpatedCountries, submittingForm: false };
        case SUBMIT_COUNTRY_FORM_FAILED:
            return { ...state, error: action.payload, submittingForm: false };

        case DELETE_COUNTRY:
            return { ...state, error: null, deleting: true };
        case DELETE_COUNTRY_SUCCESS:
            return { ...state, total: state.total - 1, countries: state.countries.filter(country => country.id !== action.payload) , deleting: false };
        case DELETE_COUNTRY_FAILED:
            return { ...state, error: action.payload, deleting: false };
        default: return { ...state };
    }
}

export default CountryReducer;